import APP_STARTUP from './actionTypes';

export default () => {
  return { type: APP_STARTUP };
};
